﻿import {translation} from "@2d-front-monorepo/core";
import {Markdown} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";

export default function PortalUnavailable(): JSX.Element {
	return (
		<section className="welcome full-layout full-layout--centered">
			<Markdown markdown={translation(PermitTranslations.features__portal_unavailable)}/>
		</section>
	)
}
